/**
 * 设置cookie
 * @param {String} key
 * @param {String} value
 * @param {Number|String|Date} end
 * @param {String} path
 * @param {String} domain
 * @param {Boolean} secure
 * @returns 
 */
type Params = {
    key: string
    value: string
    end?: number | string | Date
    path?: string
    domain?: string
    secure?: boolean,
    curMainDomain?: boolean
}
const setCookie = ({ key, value, end, path = '/', domain, secure, curMainDomain }: Params): string => {
    if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) { return '' }

    if (curMainDomain) {
        const hostnameArr = location.hostname.split('.')
        domain = '.' + hostnameArr.slice(1).join('.')
    }

    let sExpires = ''
    if (end) {
        if (typeof end == 'number') {
            sExpires = end === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + end
        } else if (typeof end == 'string') {
            sExpires = '; expires=' + end
        } else if (end instanceof Date) {
            sExpires = '; expires=' + end.toUTCString()
        }
    }
    return document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}${sExpires}${(domain ? '; domain=' + domain : '')}${(path ? '; path=' + path : '')}${(secure ? '; secure' : '')}`
}

export { setCookie }
